export const US_TIMEZONE_OPTIONS = [
  { label: 'America/New_York', value: 'America/New_York' },
  { label: 'America/Chicago', value: 'America/Chicago' },
  { label: 'America/Denver', value: 'America/Denver' },
  { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
  // Phoenix is needed because Arizona does not observe daylight saving time,
  // so using America/Denver to represent MST would be incorrect.
  { label: 'America/Phoenix', value: 'America/Phoenix' }
];
